import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export type ReportKind = 'sales' | 'stock' | 'low-stock' | 'profit' | 'debts';
export type ReportFormat = 'pdf' | 'excel';

export interface ReportOptions {
  from?: Date;
  to?: Date;
  storeIds?: string[];
  threshold?: number;
  /** Bo'sh/berilmagan bo'lsa backend tenant kotirovka valyutasini ishlatadi. */
  currency?: string;
}

// `Window.flutter_inappwebview` e'loni `src/types/flutter-bridge.d.ts` da —
// u yerdan ikkala tsconfig ham ko'radi.

@Injectable({ providedIn: 'root' })
export class ReportService {
  private http = inject(HttpClient);
  private readonly base = `${environment.apiUrl}/api/reports`;

  download(kind: ReportKind, format: ReportFormat, opts: ReportOptions): Observable<void> {
    let params = new HttpParams();
    if (kind !== 'stock' && kind !== 'low-stock') {
      if (opts.from) params = params.set('fromDate', opts.from.toISOString());
      if (opts.to) {
        const end = new Date(opts.to);
        end.setHours(23, 59, 59, 999);
        params = params.set('toDate', end.toISOString());
      }
    }
    if (kind === 'low-stock' && opts.threshold != null) {
      params = params.set('threshold', opts.threshold);
    }
    if (opts.storeIds?.length) {
      opts.storeIds.forEach((id) => (params = params.append('storeIds', id)));
    }
    if (opts.currency) params = params.set('currency', opts.currency);

    const url = `${this.base}/${kind}/${format}`;
    return this.http.get(url, { params, responseType: 'blob', observe: 'response' }).pipe(
      map((resp) => {
        const blob = resp.body as Blob;
        const ext = format === 'excel' ? 'xlsx' : 'pdf';
        const cd = resp.headers.get('Content-Disposition') ?? '';
        const match = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(cd);
        const name = match?.[1]
          ? decodeURIComponent(match[1])
          : `${kind}_${new Date().toISOString().slice(0, 10)}.${ext}`;

        const reader = new FileReader();
        reader.onloadend = (): void => {
          const base64data = reader.result as string;

          // 1. FLUTTER UCHUN: Ma'lumotni Flutter'ga yuboramiz va shu joyda TO'XTATAMIZ (return)
          if (window.flutter_inappwebview?.callHandler) {
            window.flutter_inappwebview.callHandler('FileDownloader', {
              base64: base64data,
              name: name,
            });
            return; // <-- Xavfsizlik uchun shu yerda to'xtaydi!
          }

          // 2. ODDIY BRAUZERLAR UCHUN ZAXIRA (Kompyuter yoki mobil Chrome'da kirganda)
          const objUrl = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = objUrl;
          a.download = name;
          a.click();
          URL.revokeObjectURL(objUrl); // Darhol xotirani tozalash
        };

        reader.readAsDataURL(blob);
      }),
    );
  }
}
